import { z } from "zod";
import { voiceGuesserRecordingsPerPlayerSchema } from "./game.js";

export const updateVoiceGuesserSettingsSchema = z.object({
	recordings_per_player: voiceGuesserRecordingsPerPlayerSchema,
});

export type UpdateVoiceGuesserSettingsPayload = z.infer<typeof updateVoiceGuesserSettingsSchema>;
